<div class="module-wrapper content-wrapper" *ngIf="!isStyleDetails">
  <!-- <mat-card> -->
  <mat-card-content>
    <div class="head-container">
      <h1></h1>
      <span class="spacer"></span>
      <div>
        <div class="btn-wrapper">
          <button mat-flat-button color="" (click)="openNewStyleDialog()" class="btn-warn" aria-label="Assign User(s)" > +
            {{'collectionById.styleGroups.newStyleGroup' | translate}}</button>
        </div>
      </div>
    </div>
    <div class="input-container">
      <div class="input-fields-wrapper">
        <div class="row input-wrapper">
          <!-- <div class="row"> -->
          <div class="col-md-6">
            <input type="text" class="form-control ng-untouched ng-pristine ng-valid" ng-reflect-model="" #input1 [(ngModel)]="StyleGroup"
              placeholder="{{'collectionById.styleGroups.inputStyleGroup' | translate}}" filterValidator="Name">
          </div>
          <div class="col-md-6 search-last-name">
            <input type="text" class="form-control ng-untouched ng-pristine ng-valid" ng-reflect-model="" #input2 [(ngModel)]="Style"
              placeholder="{{'collectionById.styleGroups.inputStyle' | translate}}" filterValidator="Name">
          </div>
          </div>
        <!-- </div> -->

        <div class="btn-wrapper">
          <button mat-flat-button color="" class="btn-primary" aria-label="Search" (click)="onSearch(input1.value, input2.value)">{{'collectionById.styleGroups.btnSearch' | translate}}</button>
          <button mat-flat-button color="" class="btn-flat" aria-label="Reset" (click)="onReset()">{{'collectionById.styleGroups.btnReset' | translate}}</button>
        </div>
      </div>
    </div>

    <div  class="row data-not-found-container table-container" *ngIf="isStyleGroupadded">
      <span>{{'collectionById.styleGroups.errorMsg' | translate}}</span>
    </div>
    <div *ngIf="!isStyleGroupadded">
      <div class="table-container">
        <table mat-table class="mat-elevation-z8" [dataSource]="dataSource" *ngIf="!noDataFound">
          <ng-container matColumnDef="Stylegroup">
            <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'collectionById.styleGroups.column1' | translate}}</th>
            <td mat-cell *matCellDef="let row" (click)="styleGroupDetails(row)">
              <ng-container *ngIf="row?.styleGroupName?.length > 40 then sliceTitle else noSliceTitle">
              </ng-container>

              <ng-template #sliceTitle>
                <div class="text-bold" matTooltipClass="my-custom-tooltip" matTooltip="{{row?.styleGroupName}}" matTooltipPosition="above">
                  {{row?.styleGroupName | slice: 0:40}}...</div>
              </ng-template>
              <ng-template #noSliceTitle>
                <div class="text-bold">{{row?.styleGroupName }}</div>
              </ng-template>

              <ng-container *ngIf="row?.description?.length > 40 then sliceDescription else noSliceDescription">
              </ng-container>
              <ng-template #sliceDescription>
                <div matTooltipClass="my-custom-tooltip" matTooltip="{{row?.description}}" matTooltipPosition="above" class="description-text">
                  {{row?.description | slice: 0:40}}...</div>
              </ng-template>
              <ng-template #noSliceDescription>
                <div class="description-text">{{row?.description }}</div>
              </ng-template>
            </td>
          </ng-container>
          <ng-container matColumnDef="Styles">
            <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'collectionById.styleGroups.column2' | translate}}</th>
            <td mat-cell *matCellDef="let row" (click)="styleGroupDetails(row)">
              <ng-container *ngIf="row?.styles?.length > 40 then sliceTitle else noSliceTitle">
              </ng-container>

              <ng-template #sliceTitle>
                <div class="text-bold" matTooltipClass="my-custom-tooltip" matTooltip="{{row?.styles}}" matTooltipPosition="above">
                  {{row?.styles | slice: 0:40}}...</div>
              </ng-template>
              <ng-template #noSliceTitle>
                <div class="text-bold">{{row?.styles }}</div>
              </ng-template>

            </td>
          </ng-container>
          <ng-container matColumnDef="Updated">
            <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'collectionById.styleGroups.column3' | translate}}</th>
            <td mat-cell *matCellDef="let row" (click)="styleGroupDetails(row)"><div class="text-bold">{{row.updatedBy }}</div> {{row.updated | dateAgo}}</td>
          </ng-container>
          <ng-container matColumnDef="Action">
            <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'collectionById.styleGroups.column4' | translate}}</th>
            <td mat-cell *matCellDef="let row">
              <button mat-icon-button (click)="createStyle(row)" 
              matTooltip="{{'collectionById.styleGroups.toolTip.style' | translate}}">
                <mat-icon>add</mat-icon>
              </button>
              <button mat-icon-button (click)="deleteStyleGroup(row)" 
              matTooltip="{{'collectionById.styleGroups.toolTip.delete' | translate}}">
                <mat-icon>delete</mat-icon>
              </button>


              <!-- <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="createStyle(row)">
                  <mat-icon>add</mat-icon>
                  <span>{{'collectionById.styleGroups.toolTip.style' | translate}}</span>
                </button>
                <button mat-menu-item (click)="deleteStyleGroup(row)">
                  <mat-icon>delete</mat-icon>
                  <span>{{'collectionById.styleGroups.toolTip.delete' | translate}}</span>
                </button>
              </mat-menu> -->
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true" ></tr>
          <tr class="pointer" mat-row *matRowDef="let row; columns: displayedColumns;" >{{row|json}}</tr>
        </table>
        <div class="data-not-found-container" *ngIf="noDataFound">
          <p>{{'collectionById.styleGroups.errorMsg1' | translate}}</p>
        </div>
      </div>
      <div class="styleGroup-paginator" *ngIf="styleGroupData.length > 0">
        <mat-paginator #paginator [pageSizeOptions]="[10, 50, 100]" showFirstLastButtons></mat-paginator>
      </div>
    </div>
  </mat-card-content>
</div>

<app-style-group-details *ngIf="isStyleDetails" [styleGroupDetail]="styleGroupDetail"></app-style-group-details>

<ng-template #deleteError>
  <mat-dialog-content>
    <div style="text-align: center;">
      <h4>{{deleteErrorMsg}}</h4>
      <br>
      <button mat-flat-button color="" (click)='closeDialog()' mat-raised-button class="okBtn">
        {{'collectionById.styleGroups.confirmPopup.btnOk' | translate}}
      </button>
    </div>
  </mat-dialog-content>
</ng-template>
